import { combineReducers } from 'redux'
import Immutable from 'seamless-immutable'

export const createDataBlockReducer = (baseAction, otherReducers, clearOnAttempt) => (defaultState = null) => {
  const baseActionArr = (baseAction instanceof Array) ? baseAction : [baseAction]
  const attemptingActions =  baseActionArr.map(a => `${a}_ATTEMPT`)
  const successActions = baseActionArr.map(a => `${a}_SUCCESS`)
  const failureActions = baseActionArr.map(a => `${a}_FAILURE`)

  return combineReducers({
    fetching: (state = Immutable(false), action) => {
      if (attemptingActions.indexOf(action.type) !== -1) {
        return true
      } else if (successActions.indexOf(action.type) !== -1 || failureActions.indexOf(action.type) !== -1) {
        return false
      }
      return state
    },
    error: (state = null, action) => {
      if (attemptingActions.indexOf(action.type) !== -1 || successActions.indexOf(action.type) !== -1) {
        return null
      } else if (failureActions.indexOf(action.type) !== -1) {
        return action.message || 'Oops, a problem occurred'
      }
      return state
    },
    errorCode: (state = null, action) => {
      if (attemptingActions.indexOf(action.type) !== -1 || successActions.indexOf(action.type) !== -1) {
        return null
      } else if (failureActions.indexOf(action.type) !== -1) {
        return action.code || 0
      }
      return state
    },
    count: (state = null, action) => {
      if (attemptingActions.indexOf(action.type) !== -1) {
        return clearOnAttempt ? null : state
      } else if (successActions.indexOf(action.type) !== -1) {
        return (action && action.data && action.data.count) ? action.data.count : state
      } else if (failureActions.indexOf(action.type) !== -1) {
        return null
      }
      return state
    },
    data: (state = defaultState, action) => {
      if (attemptingActions.indexOf(action.type) !== -1) {
        return clearOnAttempt ? defaultState : state
      } else if (successActions.indexOf(action.type) !== -1) {
        return (action && action.data && action.data.result) ? action.data.result : state
      } else if (failureActions.indexOf(action.type) !== -1) {
        return defaultState
      }
      return state
    },
    loaded: (state = false, action) => {
      if (attemptingActions.indexOf(action.type) !== -1) return true
      return state
    },
    ...otherReducers,
  })
}

export const updatePropReducer = (changeAction, actionPropName, nullingActions = []) => {
  nullingActions = (typeof nullingActions === 'string') ? [nullingActions] : nullingActions
  return (state = null, action) => {
    if (action.type === changeAction) {
      return action[actionPropName]
    } else if (nullingActions.indexOf(action.type) !== -1) {
      return null
    }
    return state
  }
}

export const getFilterFromAction = (state, action, key) => {
  return action.filters.hasOwnProperty(key)
      ? action.filters[key]
      : state
}